"use strict"; // Sh**t! I Smoke
// Copyright (C) 2018-2020  Marcelo S. Coelho, Amaury Martiny

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.Cigarette = void 0; // Sh**t! I Smoke is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
// Sh**t! I Smoke is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
// You should have received a copy of the GNU General Public License
// along with Sh**t! I Smoke.  If not, see <http://www.gnu.org/licenses/>.

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var butt_vertical_png_1 = __importDefault(require("../../../assets/images/butt-vertical.png"));

var butt_png_1 = __importDefault(require("../../../assets/images/butt.png"));

var head_vertical_png_1 = __importDefault(require("../../../assets/images/head-vertical.png"));

var head_png_1 = __importDefault(require("../../../assets/images/head.png"));

var styles = react_native_1.StyleSheet.create({
  butt: {
    bottom: 0,
    position: 'absolute',
    left: 0
  },
  cigarette: {
    flexGrow: 1
  },
  diagonal: {
    transform: [{
      rotate: '45deg'
    }, {
      scale: 1
    }]
  },
  head: {
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 1
  },
  inner: {
    bottom: 0,
    left: 0,
    overflow: 'hidden',
    position: 'absolute'
  }
});
/**
 * The percentage of cigarette length when `percentage=0`.
 */

var MIN_PERCENTAGE = 0.4;
/**
 * Given the full length of a cigarette, and the percentage of the cigarette
 * smoked, get the actual length of the cigarette.
 */

function getCigaretteActualLength(fullCigaretteLength, percentage) {
  return Math.ceil(((1 - MIN_PERCENTAGE) * percentage + MIN_PERCENTAGE) * fullCigaretteLength);
}
/**
 * A cigarette's width:height aspect ratio.
 */


var CIGARETTE_ASPECT_RATIO = 21 / 280;
var CIGARETTE_HEAD_HW_RATIO = 27 / 20;

function getContainerStyle(orientation, fullCigaretteLength) {
  // Assuming the cigarette is vertical:
  var height = fullCigaretteLength;
  var width = height * CIGARETTE_ASPECT_RATIO;

  switch (orientation) {
    case 'horizontal':
      {
        return {
          height: width,
          width: height
        };
      }

    case 'vertical':
      {
        return {
          height: height,
          width: width
        };
      }

    default:
      return {};
  }
}
/**
 * Render a horizontal or vertical cigarette.
 */


function renderCigarette(orientation, percentage, fullCigaretteLength, additionalStyle) {
  // Assuming cigarette is vertical:
  var height = fullCigaretteLength;
  var width = height * CIGARETTE_ASPECT_RATIO;
  var actualHeight = getCigaretteActualLength(fullCigaretteLength, percentage);
  return react_1["default"].createElement(react_native_1.View, {
    style: [getContainerStyle(orientation, fullCigaretteLength), additionalStyle]
  }, react_1["default"].createElement(react_native_1.View, {
    style: [styles.inner, orientation === 'horizontal' ? {
      height: '100%',
      width: actualHeight
    } : {
      height: actualHeight,
      width: '100%'
    }]
  }, react_1["default"].createElement(react_native_1.Image, {
    source: orientation === 'vertical' ? butt_vertical_png_1["default"] : butt_png_1["default"],
    style: [styles.butt, orientation === 'horizontal' ? {
      height: '100%',
      width: fullCigaretteLength
    } : {
      height: fullCigaretteLength,
      width: '100%'
    }]
  }), react_1["default"].createElement(react_native_1.Image, {
    source: orientation === 'vertical' ? head_vertical_png_1["default"] : head_png_1["default"],
    style: [styles.head, orientation === 'horizontal' ? {
      height: '100%',
      width: width * CIGARETTE_HEAD_HW_RATIO
    } : {
      height: width * CIGARETTE_HEAD_HW_RATIO,
      width: '100%'
    }]
  })));
}

function Cigarette(props) {
  var orientation = props.orientation,
      percentage = props.percentage,
      fullCigaretteLength = props.fullCigaretteLength,
      style = props.style; // Only used for diagonal. Assuming cigarette is vertical:

  var height = getCigaretteActualLength(fullCigaretteLength, percentage);
  var width = fullCigaretteLength * CIGARETTE_ASPECT_RATIO; // For diagonal cigarettes, we render a horizontal cigarette, and rotate it
  // 45deg.

  return orientation === 'diagonal' ? react_1["default"].createElement(react_native_1.View, {
    style: [{
      height: (height + width) / Math.SQRT2,
      width: (height + width) / Math.SQRT2
    }, style]
  }, react_1["default"].createElement(react_native_1.View, {
    style: styles.diagonal
  }, renderCigarette('horizontal', percentage, fullCigaretteLength))) : renderCigarette(orientation, percentage, fullCigaretteLength, style);
}

exports.Cigarette = Cigarette;